<header class="header">
    <div class="header__inner" [class.scrolled]="isScrolled()">
       <div class="header__mobile-menu">
             <app-mobile-side-menu [navigation]="navigation"></app-mobile-side-menu>
            <!-- <app-mobile-bottom-nav [navigation]="navigation"></app-mobile-bottom-nav> -->
        </div>




        <div class="header__logo">
            <a class="logo" routerLink="/">
                <img alt="Lidoma logo" src="../../../../assets/img/lidoma-logo-white-1.svg" />
            </a>
        </div>
        <nav class="header__navigation">
            <ul class="navigation">
                @for (navItem of navigation; track navItem) {
                    @if (!navItem.mobileOnly) {
                        <li
                            [routerLinkActiveOptions]="{
                        exact: navItem.useExact ?? false
                    }"
                            class="navigation__link"
                            routerLinkActive="navigation__link--active">
                            <div class="link-container">
                                <a [routerLink]="navItem.url">{{
                                        navItem.title | translate
                                    }}</a>
                                @if (navItem.badge) {
                                    <div class="link-badge">
                                        <span>{{ navItem.badge }}</span>
                                    </div>
                                }
                            </div>
                        </li>
                    }
                }
            </ul>
        </nav>
        <div class="header__actions">
            <!-- <app-language-selector></app-language-selector>  Temporary commented -->
            @if (isAuthorised() && (canCreateLidomaTournament() || canCreateTournament())) {
                <div class="create--tournament--button"
                    (click)="openCreateTournamentModal()"
                    type="button">
                    <img alt="add a tournament"
                         src="assets/img/icon/create-tournament-button.svg" />
                </div>
            }
            <!-- Temporary commented -->
            <!-- <div class="header__icon">
                <svg-icon src="assets/img/icon/support-icon.svg"
                          [svgStyle]="{'width.px': 20,'height.px': 20, 'fill':'#FF4647' }"></svg-icon>
            </div> -->
            @if (isAuthorised()) {
                <div class="header__icon"
                >
                    <div
                        (click)="openNotifications()"
                        class="header-button header-button--notification">
                        <svg-icon src="assets/img/icon/notification-icon.svg"
                                  [svgStyle]="{'width.px': 20,'height.px': 20, 'fill':'#FF4647' }"></svg-icon>

                        @if (countUnreadableUserNotificationsSig(); as countNotifications) {
                            <div
                                class="header-button-badge">
              <span>{{
                      countNotifications > 100 ? '99+' : countNotifications
                  }}</span>
                            </div>
                        }
                    </div>
                </div>
            }


            <!-- Temporary commented -->
            <!-- <div class="header__coins">
                <span>{{ countUnreadableUserNotificationsSig() }}</span>
                @if (isAuthorised()) {
                    <button
                        type="button">
                        <img ngSrc="assets/img/icon/redesign/lidoma-coins-gold-icon.svg" height="24" width="24" />
                    </button>
                }
            </div> -->



            <div class="header__points">

                   <!-- Temporary commented -->
                <!-- <span>{{ countUnreadableUserNotificationsSig() }}</span>
                @if (isAuthorised()) {
                    <button
                        type="button">
                        <img ngSrc="assets/img/icon/redesign/lidoma-points.png" height="24" width="24" />
                    </button>
                }-->
                @if (isAuthorised()) {
                    <app-edit-user-profile></app-edit-user-profile>
                }
                @if (!isAuthorised()) {
                    <button class="login--button" (click)="logIn()">{{ 'log_in'| translate }}</button>
                }
            </div>


        </div>
    </div>
</header>
